module.exports = __webpack_public_path__ + "static/media/hamburgerMenuLightBlue.1254bdb4.svg";